<template>
  <tr v-editable="blok">
        <td class="tg-9hbo">{{blok.headline}}</td>
        <td class="tg-031e">{{blok.description}}</td>
    </tr>
</template>

<script>
export default {
  props: ['blok'],
  data () {
    return {
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/TableRow.vue